/** A company's subcontract paperwork; required on an Active program's Sub/Consultant rows (SAD-928). */ export const SUBCONTRACT_DOCUMENT_CATEGORY = 'Subcontract';
/** A company's teaming agreement; required on a Draft program's Sub/Consultant rows (SAD-928). */ export const TEAMING_AGREEMENT_DOCUMENT_CATEGORY = 'Teaming Agreement';
/** Category options for a ProgramDocument, shared by the Docs tab and the Companies tab. */ export const DOCUMENT_CATEGORY_OPTIONS = [
    {
        value: 'PMR',
        label: 'PMR'
    },
    {
        value: 'TPP',
        label: 'TPP'
    },
    {
        value: 'Decision Log',
        label: 'Decision Log'
    },
    {
        value: 'Kickoff',
        label: 'Kickoff'
    },
    {
        value: 'Contract',
        label: 'Contract'
    },
    {
        value: SUBCONTRACT_DOCUMENT_CATEGORY,
        label: SUBCONTRACT_DOCUMENT_CATEGORY
    },
    {
        value: TEAMING_AGREEMENT_DOCUMENT_CATEGORY,
        label: TEAMING_AGREEMENT_DOCUMENT_CATEGORY
    },
    {
        value: 'Closeout',
        label: 'Closeout'
    },
    {
        value: 'Other',
        label: 'Other'
    }
];
/** The category value that routes a document into the contract re-extraction lane. */ export const CONTRACT_DOCUMENT_CATEGORY = 'Contract';
/**
 * The category value for an attachment or addendum the award relies on (a
 * deliverables schedule): a new upload is declared an attachment and filed
 * with the program's documents. Uploaded on its own it is never read; only
 * one uploaded beside its award or modification is.
 */ export const ATTACHMENT_DOCUMENT_CATEGORY = 'Attachment / Addendum';
/**
 * A team's Statement of Work or Execution Plan: ProcessBatch declares
 * document_kind=SOW so reverie runs SOW intake (SAD-898).
 */ export const SOW_DOCUMENT_CATEGORY = 'SOW / Execution Plan';
/** Shown under the category control for the SOW / Execution Plan choice. */ export const SOW_DOCUMENT_CATEGORY_HELP = "Statement of Work or Execution Plan (a team's own document)";
/**
 * Team-picker sentinel: leave workstream unset so intake proposes the team
 * from the document (baltigo's workstream_id stays empty).
 */ export const LET_SPECRA_PROPOSE_TEAM = '__propose__';
/** The Docs tab's categories: the shared ones plus attachment and SOW lanes. */ export const PROGRAM_DOCUMENT_CATEGORY_OPTIONS = [
    ...DOCUMENT_CATEGORY_OPTIONS,
    {
        value: ATTACHMENT_DOCUMENT_CATEGORY,
        label: ATTACHMENT_DOCUMENT_CATEGORY
    },
    {
        value: SOW_DOCUMENT_CATEGORY,
        label: SOW_DOCUMENT_CATEGORY
    },
    {
        value: 'NDA',
        label: 'NDA'
    },
    {
        value: 'CPARS / Performance Score',
        label: 'CPARS / Performance Score'
    },
    {
        value: 'Waiver',
        label: 'Waiver'
    },
    {
        value: 'Deliverable Evidence',
        label: 'Deliverable Evidence'
    }
];
/** The Docs tab's sections, in tab order. */ export const PROGRAM_DOCUMENT_SECTIONS = [
    'Award and Modifications',
    'Subcontractor Documents',
    'Performance Scores',
    'SOWs/EPs',
    'Evidence',
    'Other'
];
const SECTION_BY_CATEGORY = new Map(Object.entries({
    [CONTRACT_DOCUMENT_CATEGORY]: 'Award and Modifications',
    [ATTACHMENT_DOCUMENT_CATEGORY]: 'Award and Modifications',
    [SUBCONTRACT_DOCUMENT_CATEGORY]: 'Subcontractor Documents',
    [TEAMING_AGREEMENT_DOCUMENT_CATEGORY]: 'Subcontractor Documents',
    NDA: 'Subcontractor Documents',
    Modification: 'Award and Modifications',
    Reference: 'Award and Modifications',
    'CPARS / Performance Score': 'Performance Scores',
    [SOW_DOCUMENT_CATEGORY]: 'SOWs/EPs',
    Waiver: 'Evidence',
    'Deliverable Evidence': 'Evidence'
}));
/** The section a document's category files under; unknown or empty categories fall into Other. */ export function sectionForCategory(category) {
    return SECTION_BY_CATEGORY.get(category) ?? 'Other';
}
const FILE_TYPE_BY_EXTENSION = new Map(Object.entries({
    pdf: 'PDF',
    doc: 'Word',
    docx: 'Word',
    xls: 'Excel',
    xlsx: 'Excel',
    csv: 'Excel',
    ppt: 'PowerPoint',
    pptx: 'PowerPoint',
    png: 'Image',
    jpg: 'Image',
    jpeg: 'Image',
    gif: 'Image',
    webp: 'Image'
}));
/** The kind of file a document is, from its file name's extension. */ export function fileTypeForFileName(fileName) {
    const dot = fileName.lastIndexOf('.');
    const ext = dot < 0 ? '' : fileName.slice(dot + 1).toLowerCase();
    return FILE_TYPE_BY_EXTENSION.get(ext) ?? 'Other';
}
// A document attached from the Companies tab is, by default, that company's
// subcontract paperwork - the most common reason to attach a file here.
export const DEFAULT_COMPANY_DOCUMENT_CATEGORY = SUBCONTRACT_DOCUMENT_CATEGORY;
